import React, { useState, useRef, useEffect } from 'react';
import ReactPlayer from 'react-player/youtube';
import './YoutubePlayer.css';

const youtubePlaylist = [
    { id: 1, artist: 'Ben Howard', title: 'Days Of Lantana', url: 'https://www.youtube.com/watch?v=iGm9L7clwII' },  // Replace with your video IDs
    { id: 2, artist: 'ZG Smith', title: 'Nighttime Animal', url: 'https://www.youtube.com/watch?v=v3qJ8IZ1AoA' },
    { id: 3, artist: 'Jamestown Revival', title: 'Killing You, Killing Me', url: 'https://www.youtube.com/watch?v=akriaGcKC-M' },
    { id: 4, artist: 'Jon and Roy', title: 'Nothing But Everything', url: 'https://www.youtube.com/watch?v=8Eii-RNzqHQ' },
    { id: 5, artist: 'Ready Now', title: 'The National Forest', url: 'https://www.youtube.com/watch?v=ZA2Vxfz2h5M' },
    { id: 6, artist: 'Marc Broussard', title: 'Hard Times', url: 'https://www.youtube.com/watch?v=nrQCeb8kk-I' },
    { id: 7, artist: 'The Meltdown', title: 'Better Days', url: 'https://www.youtube.com/watch?v=KgP41Ei8nqg' },
    { id: 8, artist: 'Grady Spencer and The Work', title: 'Nothing Is Bad', url: 'https://www.youtube.com/watch?v=QR11yumWfrg' },
];

function YoutubePlayer({ isActive, onPlay, onPause, isPlaying }: { isActive: boolean, onPlay: () => void, onPause: () => void, isPlaying: boolean }) {
    const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
    const playerRef = useRef<ReactPlayer>(null);

    useEffect(() => {
        if (isActive && !isPlaying) {
            playerRef.current?.seekTo(0); // Reset to beginning
        }
    }, [isActive, isPlaying]);

    const handleVideoChange = (index: number) => {
        setCurrentVideoIndex(index);
        if (isActive) {
            playerRef.current?.seekTo(0); // Reset to beginning when changing track
        }
        if (!isPlaying) {
          onPlay(); // Start playing when video is changed
        }
    };

    const handlePlay = () => {
        onPlay();
    };

    const handlePause = () => {
        onPause();
    };

    return (
        <div className="youtube-player">
        <div className="video-wrapper">
        <ReactPlayer
                    ref={playerRef}
                    url={youtubePlaylist[currentVideoIndex].url}
                    playing={isActive && isPlaying}
                    controls={true}
                    width="100%"
                    height="100px"
                    onPlay={handlePlay}
                    onPause={handlePause}
                    onEnded={() => {
                        if (currentVideoIndex < youtubePlaylist.length - 1) {
                            handleVideoChange(currentVideoIndex + 1);
                        } else {
                            onPause();
                        }
                    }}
                />
        </div>
  
        {youtubePlaylist && youtubePlaylist.length > 0 && (
          <div className="track-list-container">
            <ul className="track-list">
              {youtubePlaylist.map((track, index) => (
                <li className="track-row" key={track.id} onClick={() => handleVideoChange(index)}>
                  <div className="track-number">{index + 1}</div>
                  <div className="track-info">
                    <div className="track-artist">{track.title}</div>
                    <div className="track-title">{track.title}</div>
                  </div>
                  <div className="track-actions">
                    <i className="fa fa-play play-icon"></i> {/* Use a Font Awesome icon */}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
}

export default YoutubePlayer;